export enum NotificationType {
  Push = 'Push',
  SMS = 'SMS',
}
